import { removeReferences, restoreReferences } from '../cache/helpers';
import {
    NodeTypename,
    ObjectType,
} from '@precon-tools-suite-by-shared/precon-graphql-types';
import { useApolloClient } from '@vue/apollo-composable';

export function useCacheCleanup() {
    const cache = useApolloClient().resolveClient().cache;

    /**
     * Removes references from a field with an array of references.
     *
     * @param id - The ID of the cache item to remove the references from.
     * @param fieldName - The field to remove the references from.
     * @param references - The reference IDs to remove.
     * @returns {string[]} - The list of references that were removed.
     */
    function clean<N extends NodeTypename>(
        id: string,
        fieldName: keyof ObjectType<N>,
        references: string[]
    ): string[] {
        return references.length > 0
            ? removeReferences(cache, id, fieldName, references)
            : references;
    }

    /**
     * Restores references to a field with an array of references.
     *
     * @param id - The ID of the cache item to restore the references to.
     * @param fieldName - The field to restore the references to.
     * @param references - The reference IDs to restore.
     */
    function restore<N extends NodeTypename>(
        id: string,
        fieldName: keyof ObjectType<N>,
        references: string[]
    ) {
        if (references.length > 0)
            restoreReferences(cache, id, fieldName, references);
    }

    return { clean, restore };
}
